import { Navigate, useLocation } from 'react-router-dom';
import navConfig from 'src/layouts/dashboard/nav/config';
import { tokenService } from 'src/services';

const normalize = (p = '') => p.split('?')[0].replace(/\/+$/, '');

const afterDashboard = (p = '') => {
  const path = normalize(p);
  if (path === '/dashboard') return ''; // kritik: dashboard kökü
  return path.startsWith('/dashboard/')
    ? path.slice('/dashboard/'.length)
    : path;
};

// exact match veya en uzun prefix match
const findBestNavMatch = (pathname) => {
  const current = afterDashboard(pathname); // örn: "support-tickets/123" veya ""

  // dashboard root ("/dashboard") için izin kontrolü yapmayacağız
  if (current === '') return { __dashboardRoot: true };

  let exact = null;
  let bestPrefix = null;
  let bestLen = -1;

  for (const item of navConfig) {
    if (!item?.path) continue;

    const candidate = afterDashboard(item.path); // örn: "support-tickets"
    if (!candidate) continue;

    if (candidate === current) {
      exact = item;
      break;
    }

    if (current.startsWith(candidate + '/')) {
      if (candidate.length > bestLen) {
        bestLen = candidate.length;
        bestPrefix = item;
      }
    }
  }

  return exact || bestPrefix || null;
};

const generateCombinedPermissions = (
  accountCategory,
  frontAuthArray,
  userType
) => {
  const arr = Array.isArray(frontAuthArray) ? frontAuthArray : [];
  return arr.map((frontAuth) => `${accountCategory}:${frontAuth}:${userType}`);
};

const isAllowedByNavItem = (user, navItem) => {
  // dashboard root: login olan geçsin, DashboardIndex zaten yönlendirecek
  if (navItem?.__dashboardRoot) return true;

  // dashboard içinde eşleşme yoksa: 404 (kapalı politika)
  if (!navItem) return false;

  const accountCategory = user?.accountCategory || '';
  const userType = user?.type;
  const frontAuthArray = Array.isArray(user?.frontAuth) ? user.frontAuth : [];

  const combinedPermissions = generateCombinedPermissions(
    accountCategory,
    frontAuthArray,
    userType
  );

  if (
    Array.isArray(navItem.hiddenForFrontAuth) &&
    navItem.hiddenForFrontAuth.some((auth) => frontAuthArray.includes(auth))
  ) {
    return false;
  }

  if (
    Array.isArray(navItem.permissionCombination) &&
    navItem.permissionCombination.length > 0
  ) {
    const ok = navItem.permissionCombination.every((perm) =>
      frontAuthArray.includes(perm)
    );
    if (!ok) return false;
  }

  const required = Array.isArray(navItem.permissions)
    ? navItem.permissions
    : [];
  if (required.length === 0) return true;

  return required.some((perm) => combinedPermissions.includes(perm));
};

// Kullanıcının navConfig sırasına göre erişebildiği ilk sayfayı döner.
// DashboardIndex, sabit bir hedefe (ör. /dashboard/app) yetkisiz yönlendirip
// ProtectedRoute'un onu geri /dashboard'a atmasıyla oluşan sonsuz döngüyü
// (beyaz ekran + adres çubuğunda titreme) önlemek için bunu kullanır.
export const getFirstAllowedNavPath = (user) => {
  if (!user) return null;
  for (const item of navConfig) {
    if (!item?.path || item.hidden) continue;
    if (isAllowedByNavItem(user, item)) return item.path;
  }
  return null;
};

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const pathname = normalize(location.pathname);

  // Dashboard dışı hiçbir yer login istemiyor (kuralınız)
  if (!pathname.startsWith('/dashboard')) {
    return children;
  }

  const user = tokenService.getUser();

  // Login değilse: her zaman login'e
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Login ise: navConfig üzerinden yetki kontrolü
  const matchedNavItem = findBestNavMatch(pathname);
  const allowed = isAllowedByNavItem(user, matchedNavItem);

  if (!allowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
